const calendarEventsTimeframesOptions = {
  today: "Today's events",
  tomorrow: "Tomorrow's events",
  seven_days: "Next 7 days of events",
};

export default calendarEventsTimeframesOptions;
